import { useAbility } from '@casl/react';
import MemoryOutlinedIcon from '@mui/icons-material/MemoryOutlined';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ACTIONS } from 'src/auth/utils/defineAbilityFor';
import { AbilityContext } from 'src/context/canContext';

import pages from '../../../router/routes';

interface Props {
  onActivate?: () => void;
}

export default function HardwareMenuItem({ onActivate }: Props) {
  const navigate = useNavigate();
  const ability = useAbility(AbilityContext);
  const isSuperAdmin = ability.can(ACTIONS.MANAGE, 'all');

  if (!isSuperAdmin) return null;

  return (
    <ListItemButton
      sx={{ borderRadius: 0 }}
      onClick={() => {
        navigate(pages.hardware.path);
        onActivate?.();
      }}
    >
      <ListItemIcon>
        <MemoryOutlinedIcon />
      </ListItemIcon>
      <ListItemText primary='Supported Hardware' />
    </ListItemButton>
  );
}
